export const XYCHART_EVENT_SOURCE = '__XY_EVENT_SOURCE__';